import React, { PureComponent } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { Button, Cell, DataTable, DialogContainer, Grid, Paper, SelectionControl, TableBody, TableColumn, TableHeader, TableRow, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import '../css/settings.css';
import styles from '../css/styles.css.js';
import crossIcon from '../images/png/crossIcon.png';
import editIcon from '../images/png/edit.png';
import ApiRequestService from './ApiRequestService';
import LoadingSpinner from './LoadingSpinner';
import { AppProperties } from '../common/function';
import archivedIcon from '../images/png/archivedIcon.png'
import notArchivedIcon from '../images/png/notArchivedIcon.png'
import archiveProcessIcon from "../images/png/archiveProcess.png" 




export default class Semester extends PureComponent  {

    appProperties = AppProperties();

    constructor(props){
        super(props);

        this.state={
            semesters:[],
            loadingSemesterData:false,
            showAddSemDialog:false,            
            addMode:true,
            semesterStates: {}
        };

        this.selectedSemester = {};
    }

    componentWillMount(){

        this.setState({loadingSemesterData:true});
        this.getAllSemesters().then( semesters => {
            if(semesters){
                this.setState({semesters,loadingSemesterData:false});
            }
        })
    }

    //API Calls
    getAllSemesters = async () => {
        let getAllSemestersResp = await  ApiRequestService({
                method: 'post',
                url: '/getAllSemesters'
            });

        try{
            if(getAllSemestersResp && getAllSemestersResp.data && getAllSemestersResp.data.data){
                return  getAllSemestersResp.data.data;
            }else if(getAllSemestersResp.data && getAllSemestersResp.data.status && getAllSemestersResp.data.message ){
                NotificationManager.error("Get All Semesters Failed with Error - "+getAllSemestersResp.data.message,"Error",5000);
            }else{
                NotificationManager.error("Get All Semesters Failed with Unknown Error","Error",5000);
            }
        }catch(err){
            NotificationManager.error("Get All Semesters Failed with Error "+err,"Error",5000);
        }

        return null;
    }

    addSemesterRequest = async (semesterData) => {
        
        let addSemesterResp = await  ApiRequestService({
            method: 'post',
            url: '/addSemester',
            data:semesterData
        });

        try{

            
            if(addSemesterResp.data){
                if(addSemesterResp.data.status === 0){
                    NotificationManager.success((this.appProperties.schoolMode?"Academic year Added":"Semester Added"),"Success",5000);
                    return 0;
                }else
                NotificationManager.error("Add Semester Failed with Error - "+addSemesterResp.data.message,"Error",5000);
            }else{
                NotificationManager.error("Add Semester Failed with Unknown Error","Error",5000);
            }
        }catch(err){
            NotificationManager.error("Add Semester Failed with Error "+err,"Error",5000);
        }

        return null;
    }

    editSemesterRequest = async(semesterData) => {
        let addSemesterResp = await  ApiRequestService({
            method: 'post',
            url: '/updateSemester',
            data:semesterData
        });

        try{
            if(addSemesterResp.data){
                if(addSemesterResp.data.status === 0){
                    NotificationManager.success((this.appProperties.schoolMode?"Academic year Updated":"Semester Updated"),"Success",5000);
                    return 0;
                }else
                NotificationManager.error("Update Semester Failed with Error - "+addSemesterResp.data.message,"Error",5000);
            }else{
                NotificationManager.error("Update Semester Failed with Unknown Error","Error",5000);
            }
        }catch(err){
            NotificationManager.error("Update Semester Failed with Error "+err,"Error",5000);
        }

        return null;
    }

    deleteSemesterRequest = async(semesterData) =>{
        let addSemesterResp = await  ApiRequestService({
            method: 'post',
            url: '/deleteSemester',
            data:semesterData
        });

        try{
            if(addSemesterResp.data){
                if(addSemesterResp.data.status === 0){
                    NotificationManager.success((this.appProperties.schoolMode?"Academic year Deleted":"Semester Deleted"),"Success",5000);
                    return 0;
                }else
                NotificationManager.error("Delete Semester Failed with Error - "+addSemesterResp.data.message,"Error",5000);
            }else{
                NotificationManager.error("Delete Semester Failed with Unknown Error","Error",5000);
            }
        }catch(err){
            NotificationManager.error("Delete Semester Failed with Error "+err,"Error",5000);
        }

        return null;
    }

    changeCurrentSemesterRequest = async(semesterData) => {
        let addSemesterResp = await  ApiRequestService({
            method: 'post',
            url: '/changeCurrentSemester',
            data:semesterData
        });

        try{
            if(addSemesterResp.data){
                if(addSemesterResp.data.status === 0){
                    NotificationManager.success((this.appProperties.schoolMode?"Current Academic year Changed":"Current Semester Changed"),"Success",5000);
                    return 0;
                }else
                NotificationManager.error("Current Semester Change Failed with Error - "+addSemesterResp.data.message,"Error",5000);
            }else{
                NotificationManager.error("Current Semester Change with Unknown Error","Error",5000);
            }
        }catch(err){
            NotificationManager.error("Current Semester Change with Error "+err,"Error",5000);
        }

        return null;
    }
    //Actions & Events
    addSemesterDialog = () => {

        this.setState({showAddSemDialog:true,addMode:true});
    }

    editSemesterDialog = (selectedSemester) => {
        this.setState({showAddSemDialog:true,addMode:false,selectedSemesterName:selectedSemester.name});
        this.selectedSemester = selectedSemester;
    }
    hideSemesterDialog = () => {
        this.setState({showAddSemDialog:false})
    }

    onAddSemester = () => {
        this.selectedSemester.name = this.state.selectedSemesterName;
        this.addSemesterRequest(this.selectedSemester).then(status => {
            if(status === 0){
                this.setState({showAddSemDialog:false});
                this.getAllSemesters().then( semesters => {
                    if(semesters){this.setState({semesters,loadingSemesterData:false})}
                })}})
    }

    onEditSemester = () => {
        this.selectedSemester.name = this.state.selectedSemesterName;
        this.editSemesterRequest(this.selectedSemester).then(status => {
            if(status === 0){
                this.setState({showAddSemDialog:false});
                this.getAllSemesters().then( semesters => {
                    if(semesters){this.setState({semesters,loadingSemesterData:false})}
                })}
            })
    }

    onDeleteSemester = (selectedSemester) => {
        if(selectedSemester.isCurrent){
            NotificationManager.error("You cannot Delete Current Semester","Error",10000);
        }else{
            confirmAlert({
                title: (this.appProperties.schoolMode?
                    'Are you sure want to delete this Academic year? You wont be able to access archived data!'
                    :'Are you sure want to delete this Semester? You wont be able to access archived data!'),
                message: 'Press Confirm to submit',
      
                cancelLabel: 'Confirm',
                confirmLabel: 'Cancel',
                onCancel: () => this.deleteSemesterRequest(selectedSemester).then( status =>{
                    if(status === 0){
                        
                        this.getAllSemesters().then( semesters => {
                            if(semesters){this.setState({semesters,loadingSemesterData:false})}
                        })}
                })
              })
        }
    }

    onCurSemChange = (selectedSemester) =>{
        this.setState({loadingSemesterData:true});
        confirmAlert({
            title: (this.appProperties.schoolMode?
                'WARNING!!! This will remove standards, sections and assignments from the current academic year. To save the data for the current academic year, please archive it in the “Settings” menu.  Do you wish to proceed changing the current academic year?'
                :'WARNING!!! This will remove courses, sections and assignments from the current semester. To save the data for the current semester, please archive it in the “Settings” menu.  Do you wish to proceed changing the current semester?'),
            message: 'Press Confirm to submit',
  
            cancelLabel: 'Confirm',
            confirmLabel: 'Cancel',
            onCancel: () => this.changeCurrentSemesterRequest(selectedSemester).then( status =>{
                if(status === 0){
                    
                    this.getAllSemesters().then( semesters => {
                        if(semesters){this.setState({semesters,loadingSemesterData:false})}
                    })}
            }),
            onConfirm: () =>{
                this.setState({loadingSemesterData:false})
            }
          })
    }

    onSemNameChange = (semName) => {
        this.setState({selectedSemesterName:semName});
        this.forceUpdate();
    }

   
    handleProcessArchiveIcon =(semesterId)=> {
        this.setState(prevState => ({
          semesterStates: {
            ...prevState.semesterStates,
            [semesterId]: !prevState.semesterStates[semesterId]
          }
        }));
      }
    render(){

        let semesterName ='';
        if(this.state.selectedSemesterName){
            semesterName = this.state.selectedSemesterName;
        }
     
        return [<Grid key="SemesterTable">
                    <Cell size={12} className="semester-title">
                    <h3>{this.appProperties.schoolMode?"Academic Years":"Semesters"}</h3>
                        <Button className="archive-button" primary raised
                        style={{float: "right"}}
                        onClick={this.addSemesterDialog}>
                        Add a New Semester
                        </Button>
                    </Cell>
                    <Cell size={12}  className="semester-table-container"><SemesterDataTable editSemester={this.editSemesterDialog} 
                        deleteSemester={this.onDeleteSemester}
                        onCurSemChange={this.onCurSemChange}
                        loading={this.state.loadingSemesterData} semesterList={this.state.semesters}
                        archiveSemester={this.props.archiveSemester} showProcessArchiveIcon={this.state.semesterStates} onclickProcessArchiveIcon={this.handleProcessArchiveIcon}
                        /></Cell>
                </Grid>,
                <AddSemesterDialog 
                key="SemesterDialog"
                visible={this.state.showAddSemDialog}
                hide={this.hideSemesterDialog} 
                onSemNameChange={this.onSemNameChange}
                add={this.onAddSemester}
                update={this.onEditSemester}
                addMode={this.state.addMode}
                semesterName={semesterName}
                />];
    }
}


const SemesterDataTable = (props) => {
    
     const handleArchiveClick =(semesterID)=>{
          props.archiveSemester(semesterID)
          props.onclickProcessArchiveIcon(semesterID)
     }
    const appProperties = AppProperties();
    if(props.loading){
        return  <LoadingSpinner/>
    }
    if(props.semesterList){
        return <DataTable plain>
                <TableHeader>
                <TableRow>
                    <TableColumn>ID</TableColumn>
                    <TableColumn>Name</TableColumn>
                    <TableColumn style={{textAlign :'center',width:'314px'}}>Actions</TableColumn>
                </TableRow>
                </TableHeader>
                <TableBody>
                {props.semesterList.map((semester, _) => (
                    <TableRow key={semester.id}>
                        <TableColumn>{semester.id}</TableColumn>
                        <TableColumn>{semester.name}</TableColumn>
                        <TableColumn style={{display:'flex',gap:'20px'}}>
                            <div class="actionButton">
                            <Button icon >
                                <img src={editIcon} alt="Edit"
                                onClick={() => props.editSemester(semester)}
                                />
                                
                            </Button>
                            <span class="actionToolTip" >Edit</span>
                            </div>
                            <div class='actionButton'>                            
                            <Button icon  
                                    onClick={() => props.deleteSemester(semester)}>
                                <img
                                    src={crossIcon}
                                    alt="Delete"
                                />
                            </Button>
                            <span class="actionToolTip">Delete</span>
                            </div>
                            <div class='actionButton'>
                            <SelectionControl
                            id={"switch-current-semester"+semester.id}
                            type="switch"
                            name="currentSemester"
                            label={null}
                            checked={semester.isCurrent}
                            disabled={semester.isCurrent}
                            onChange={() => props.onCurSemChange(semester)}
                            />
                             <span class="actionToolTip">{appProperties.schoolMode?"Current Academic Year":"Current Semester"}</span>
                            </div>
                            <div class='actionButton' style={{ width :'200px'}}>
                            <Button  icon 
                                    onClick={() =>handleArchiveClick(semester.id)}>
                                <img
                                    style={{ width:'25px',height:'25px'}}
                                    src={semester.archive_status_code ===2? archivedIcon: ((props.showProcessArchiveIcon[semester.id] && semester.id) || semester.archive_status_code ===1 ? archiveProcessIcon :  notArchivedIcon)}
                                    alt="archive semester"
                                />
                            </Button>
                              {semester.archive_status_code ===2 ?
                                   <span class="actionToolTip">
                                   <fieldset className='archive-tooltip'>
                                     <legend>  Archived Semester</legend>
                                   <div>{semester.archive_status_code ===2 ? 
                                   
                                   <div>
                                    <ul className='archive-btn-list'>
                                    <li> {`Last archived on ${semester.lastArchived.split(" ")[0]}.`}</li>
                                    <li>{`Sometimes we can't get the accurate date due to technical difficulties. So we use the semester's
                                    final assignment's due date as last archive date.`}</li>
                                    </ul>

                                    </div> 
                                    
                                    :null} </div>                
                                   
                                   </fieldset></span>
                                   :
                                   <span class="actionToolTip">
                                   <fieldset className='archive-tooltip'>
                                   <legend>
                                   {
                                    (props.showProcessArchiveIcon[semester.id]  && semester.id) || semester.archive_status_code ===1 ?
                                    "Archival in progress": "Archive Semester"
                                   }
                                   </legend>
                                   <ul className='archive-btn-list'>
                                   
                                   <li>Archival will make a copy of the {appProperties.eqmMode?'Result':'raw data'} and gradebook for tests/assignments that have ended in the current {appProperties.schoolMode?'Academic year':'semester'}.</li> 
                                   <li>The archived data can be found in the Archive menu</li>
                                   <li>Don't delete any {appProperties.schoolMode?'standards':'courses'} and sections after archival. Switch on the &quot;Current {appProperties.schoolMode?'Academic year':'semester'}&quot; for the newly added {appProperties.schoolMode?'Academic year':'semester'} and all existing {appProperties.schoolMode?'standards':'courses'} and sections will automatically be removed from the Dashboard.</li>
                                   </ul>
                                  
                                   </fieldset></span>
                              
                              } 
                            </div>
                            
                            
                        </TableColumn>
                    </TableRow>
                ))}
                </TableBody>
            </DataTable>
    }

    return <Paper>
                {appProperties.schoolMode?"No Academic Year data found ":"No Semester data found "}   
            </Paper>;
    
}

var AddSemesterDialog = (props) =>{
    const appProperties = AppProperties();
    var onSemesterValueChange = (e) => {
        if(e){
            props.onSemNameChange(e);
        }
    }

    let button = null;
    let semesterName = undefined;
    if(props.semesterName && !props.addMode){
        semesterName = props.semesterName;
    }
    if(props.addMode){
    button = <Button raised primary onClick = {props.add}>
        {appProperties.schoolMode?'Add Academic Year':'Add Semester'}</Button>
    }
    else{
        button = <Button raised primary onClick = {props.update}> 
        {appProperties.schoolMode?'Update Academic Year':'Update Semester'}</Button>
    }
    var cancelButton = <Button flat primary onClick={props.hide}>Cancel</Button>

    const actions = [];
    actions.push(cancelButton);
    actions.push(button);

    return <DialogContainer
                id="add-semester-dialog"
                visible={props.visible}
                onHide={props.hide}
                actions={actions}
               // title="Semester"
                width={400}
                key="AddInstructorDialog"
                >
               <h2> <label for="semId">{appProperties.schoolMode?'Academic Year':'Semester'}</label></h2>
{/*             <input 
                id="semId"
                type="text"
                name="semester_name"
                onChange = {onSemesterValueChange}
                value={semesterName}
                /> */}
            <TextField 
                id="semId"
                type="text"
                name="semester_name"
                onChange = {onSemesterValueChange}
                value={semesterName}
                className="md-cell md-cell--12" 
                required
            />

            </DialogContainer>
}